<div class="main-wrapper">
	<div class="main-content">
		<!-- global markup for header -->
		<header class="header">
			<div class="content">
				<div class="header__block row">
					<div class="header__arrow col image" (click)="BackToDohot()"><img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span></div>
					<div class="header__title col">{{ _text.store.productPerBarcodeManagement }}</div>
					<div class="header__burger col image">
						<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
					</div>
				</div>
			</div>

			<div class="report-table__row no-print">
				<div class="header__search header__search_small relative" style="width: 99%; margin: auto; margin-top: 10px">
					<form>
						<input class="header__search-input" type="text" placeholder="חפש" [formControl]="searchFormControl" id="search-Input" style="text-align: center; direction: rtl" />
					</form>
					<button class="header__clear-icon" (click)="searchFormControl.reset()"></button>
				</div>
				<span class="absolute" style="left: 50%; bottom: 0; transform: translateX(-50%); color: white; padding-top: 4px">מציג ( {{ totalShown$ | async }} ) פריטים</span>
			</div>

			<!-- <h2 style="text-align: center" *ngIf="LoadingBack === true">טוען אנא המתן</h2> -->
		</header>

		<section class="report-table" style="margin-top: 60px">
			<div class="content">
				<div style="display: flex; justify-content: space-between; align-items: center">
					<div class="product-detail__button flex justify-align-center" (click)="openNewBarcodeProductDrawer()">פריט חדש</div>
				</div>

				<div class="report-table__row report-table__row_between"></div>

				<div class="report-table__row report-table__row_full-width">
					<div class="loading" *ngIf="loading">
						<mat-spinner color="primary"></mat-spinner>
					</div>
					<mat-progress-bar *ngIf="isLoadingProgressBarShowing" style="position: absolute" mode="indeterminate"></mat-progress-bar>
					<ng-container *ngIf="productsDisplay$ | async as productsToBarcode">
						<table class="report-table__table" cellspacing="0" *ngIf="productsToBarcode.length && !loading; else noAlertsBlock" dir="rtl">
							<thead class="report-table__table-head">
								<tr>
									<th class="report-table__table-head-name">קוד פריט</th>
									<th class="report-table__table-head-name">מק"ט מברקוד</th>
									<th class="report-table__table-head-name">מזהה ברקוד</th>
									<th class="report-table__table-head-name">כמות ברירת מחדל</th>
									<th class="report-table__table-head-name">אריזות ברירת מחדל</th>
									<th class="report-table__table-head-name">פעולות</th>
								</tr>
							</thead>
							<tbody class="report-table__table-body">
								<tr *ngFor="let product of productsToBarcode">
									<td class="report-table__table-body-name">{{ product.ProductId }}</td>
									<td class="report-table__table-body-name">{{ product.IdFromBarcode }}</td>
									<td class="report-table__table-body-name">{{ product.BarcodeName || 'ללא שיוך' }}</td>
									<td class="report-table__table-body-name">{{ product.QTYDefault }}</td>
									<td class="report-table__table-body-name">{{ product.QTYPackDefault }}</td>

									<td class="report-table__table-body-name bold text-align-center">
										<div class="flex gap">
											<button mat-raised-button (click)="handleEditProductBarcode(product)">ערוך</button>
											<button mat-raised-button color="primary" (click)="handleChangeProdcut($event, product.RowID, 'delete')">מחק</button>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</ng-container>

					<ng-template #noAlertsBlock>
						<h1>אין נתונים להציג</h1>
					</ng-template>
					<!-- <h1 *ngIf="FilterLoading === false && !allSpecials.length">אין נתונים להציג</h1> -->
				</div>
			</div>
		</section>
	</div>
</div>

<!-- markup for sort popup -->
<div class="popup" *ngIf="productBarcodeDrawerOpen">
	<div class="overlay"></div>
	<div class="report-table-popup report-table-popup_sort popup__content">
		<div class="popup__close" (click)="closeDrawer()"></div>
		<div class="report-table-popup__header">
			<div class="report-table-popup__header-search"></div>
			<div class="report-table-popup__header-title">{{ isEdittingBarcodeProduct ? 'עריכת פריט' : 'פריט חדש' }}</div>
		</div>
		<div class="report-table-popup__wrapper">
			<div class="report-table-popup__content">
				<div class="loading" *ngIf="loading; else formBlock">
					<mat-spinner color="primary"></mat-spinner>
					<h3 style="text-align: center; direction: rtl">טוען...</h3>
				</div>
				<ng-template #formBlock>
					<div class="report-table-popup__row report-table-popup__row_no-border report-table-popup__row_double">
						<div *ngIf="updateSuccess; else alertChangeBlock" style="width: 100%; display: grid; place-items: center">
							<h3 style="text-align: center; color: var(--valid-color)">פריט {{ isEdittingBarcodeProduct ? 'עודכן' : 'נוסף' }} בהצלחה!</h3>
							<button mat-raised-button color="primary" (click)="closeDrawer()">סגור</button>
						</div>

						<ng-template #alertChangeBlock>
							<form [formGroup]="form" dir="rtl" autocomplete="off" class="flex flex-column gap" (ngSubmit)="handleFormSubmit()">
								<mat-form-field color="primary">
									<mat-label>קוד פריט</mat-label>
									<input matInput placeholder="קוד פריט" type="text" formControlName="productID" inputmode="numeric" />
									<mat-error *ngIf="form.controls.productID.hasError('required')">שדה חסר או אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>מזהה ברקוד</mat-label>
									<mat-select autoActiveFirstOption formControlName="barcodeDefId">
										<mat-option *ngFor="let def of definitions$ | async" [value]="def.Id">
											<span style="unicode-bidi: isolate">{{ def.Id }}</span> - <span style="unicode-bidi: isolate">{{ def.BarcodeName }}</span>
										</mat-option>
									</mat-select>
									<mat-error>יש לבחור מזהה מהרשימה</mat-error>
								</mat-form-field>
								<!-- <mat-form-field color="primary">
									<mat-label>מזהה ברקוד</mat-label>
									<input type="text" placeholder="מזהה ברקוד" aria-label="barcodeDefId" matInput formControlName="barcodeDefId" [matAutocomplete]="auto" />
									<mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
										<mat-option *ngFor="let def of definitionsDisplay$ | async" [value]="def.Id">
											<span style="unicode-bidi: isolate">{{ def.Id }}</span> - <span style="unicode-bidi: isolate">{{ def.BarcodeName }}</span>
										</mat-option>
									</mat-autocomplete>
									<mat-error>יש לבחור מזהה מהרשימה</mat-error>
								</mat-form-field> -->
								<mat-form-field color="primary">
									<mat-label>מק"ט מברקוד</mat-label>
									<input matInput placeholder='מק"ט מברקוד' type="text" formControlName="idFromBarcode" />
									<mat-error> שדה חסר או אינו תקין </mat-error>
								</mat-form-field>
								<mat-error *ngIf="form.hasError('invalidBarcode') || form.hasError('invalidBarcodeDefinition')">מקט לא תואם להגדרת הברקוד</mat-error>
								<mat-error *ngIf="form.hasError('duplicateProduct')">פריט זה כבר קיים ברשימה</mat-error>
								<mat-form-field color="primary">
									<mat-label>כמות ברירת מחדל</mat-label>
									<input matInput placeholder="ללא" type="text" formControlName="quantity" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>
								<mat-form-field color="primary">
									<mat-label>אריזות ברירת מחדל</mat-label>
									<input matInput placeholder="ללא" type="text" formControlName="packQuantity" />
									<mat-error>שדה אינו תקין</mat-error>
								</mat-form-field>

								<button mat-raised-button type="button" *ngIf="isDevelopment" (click)="logDummyBarcodeForSelectedDefinition()">LOG BARCODE</button>

								<div class="report-table-popup__button-wrapper" style="position: relative">
									<button class="report-table-popup__button" [ngClass]="{ darken: form.invalid }">{{ isEdittingBarcodeProduct ? 'ערוך' : 'אשר' }}</button>
								</div>
							</form>
						</ng-template>
					</div>
				</ng-template>
			</div>
		</div>
	</div>
</div>
